document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-psk-carousel]').forEach(function (root) {
    var slides = root.querySelectorAll('.psk-carousel__slide');
    if (!slides.length) return;

    var dotsWrap = root.querySelector('.psk-carousel__dots');
    var idx = 0;

    slides.forEach(function (_, i) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.setAttribute('aria-label', 'Show image ' + (i + 1));
      if (i === 0) dot.classList.add('is-active');
      dot.addEventListener('click', function () { show(i); });
      dotsWrap.appendChild(dot);
    });

    function show(n) {
      idx = (n + slides.length) % slides.length;
      slides.forEach(function (s, i) { s.classList.toggle('is-active', i === idx); });
      dotsWrap.querySelectorAll('button').forEach(function (b, i) { b.classList.toggle('is-active', i === idx); });
    }

    var prev = root.querySelector('.psk-carousel__prev');
    var next = root.querySelector('.psk-carousel__next');
    if (prev) prev.addEventListener('click', function () { show(idx - 1); });
    if (next) next.addEventListener('click', function () { show(idx + 1); });
  });
});
